import { Injectable } from '@angular/core';
import { PublicationModel } from '../nmodels/publication.model';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { SinglePost, PostByUserModel } from '../nmodels/postbyuser.model';
import { LocationModel } from '../models/location.model';
import { FilterModel } from '../models/filterModel';

@Injectable()
export class SharedinfoService {

  private publications:PublicationModel[] = [];
  private temporalPublication?:PublicationModel = new PublicationModel();
  private asParampublication?:PublicationModel;
  private asParamPostByUserModel?:PostByUserModel;
  private lastLocation:LocationModel;
  private lastsearch:string;
  private filterparams:FilterModel;
  private toback:number;
  private publicationsfiltered:PublicationModel[] = [];
  
  private sharedtoback = new BehaviorSubject<number>(this.toback);
  private sharedPublications = new BehaviorSubject<PublicationModel[]>(this.publications);
  private sharedPublication = new BehaviorSubject<PublicationModel>(this.temporalPublication);

  public subjecttoback = this.sharedtoback.asObservable();
  public subjectPublications = this.sharedPublications.asObservable();
  public subjectTemporalPublication = this.sharedPublication.asObservable();

  constructor() { }

  updatePublications(publications:PublicationModel[]){
    this.sharedPublications.next(publications);
    this.lastLocation = null;
  }
  updateTemporalPublication(publication:PublicationModel){
    this.sharedPublication.next(publication);
  }
  updatetoback(toback:number){
    console.log("shared service: se recibio to back "+toback);
    
    this.sharedtoback.next(toback);
  }
  /**
   * si se tiene una publicacion almacenada como asParamPublication la retorna si no retorna null
   */
  getasParamPublication(){
    if(this.asParampublication!=null)
      return this.asParampublication;
    else return null;
  }
  /**
   * almacena una publicacion considerada como parametro
   */
  setasParamPublication(publication:PublicationModel){
    if(publication==null) this.asParampublication = null;
    else this.asParampublication = publication;
  }
  /**
   * si existe una publicacion con formato PostByUserModel la retorna, si no retorna null
   */
  setasParamPostByUserModel(publication:PostByUserModel){
    if(publication == null)this.asParamPostByUserModel = null;
    else this.asParamPostByUserModel = publication;
  }
  getasParamPostByUSerModel(){
    if(this.asParamPostByUserModel!=null)
      return this.asParamPostByUserModel;
    else return null;
  }

  getlastLocation(){
    if(this.lastLocation){
      return this.lastLocation;
    }
    else return null;
  }

  setlastLocation(location:LocationModel){
    this.lastLocation = location;
    this.publicationsfiltered = null;
  }

  setPublicationsFiltered(filtered:PublicationModel[]){
    this.publicationsfiltered = filtered;
    this.lastLocation = null;
  }
  getPublicationsFiltered(){
    if(this.publicationsfiltered) return this.publicationsfiltered;
    else return null;
  }
  setLastSearch(lastsearch:string){
    this.lastsearch = lastsearch;
  }
  getLastSearch(){
    return this.lastsearch;
  }

  setFilterParams(filterparams:FilterModel){
    this.filterparams = filterparams;
  }
  getFilterParams(){
    return this.filterparams;
  }


}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/nservices/sharedinfo.service.ts